import { Component, OnInit, OnDestroy } from '@angular/core';
import { ReportingService } from '../reporting.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../../login/login.service';
import { ReportFolder } from '../models/report-folder.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { AddReportFolderComponent } from './add-folder/add-folder.component';
import { DeleteReportFolderComponent } from './delete-folder/delete-folder.component';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';

@AutoUnsubscribe()
@Component({
    selector: 'reportFolders',
    templateUrl: './report-folders.component.html',
    styleUrls: ['./report-folders.component.css']

    // entryComponents: [
    //     ReportParametersComponent
    //     ]
})

export class ReportFoldersComponent implements OnInit, OnDestroy {

    thisDialogRef: MatDialogRef<ReportFoldersComponent>;
    angularMatData = new TylerMatTableDataSource;
    columnsToDisplay: string[] = ['ReportFolderName', 'Description', 'Total', 'Actions'];

    reportFolders: ReportFolder[];
    reportFoldersOnLoad: ReportFolder[];

    addReportFolderDialogRef: MatDialogRef<AddReportFolderComponent>;
    deleteReportFolderDialogRef: MatDialogRef<DeleteReportFolderComponent>;
    isDirty: boolean;

    reportFolderChanged = false;

    // addReportFolderDialog: MatDialog;

    constructor(
        reportFoldersDialogRef: MatDialogRef<ReportFoldersComponent>,
        private reportService: ReportingService,
        // private myReportsComponent: MyReportsComponent
        private loginService: LoginService,
        private dialog: MatDialog,

        private addReportFolderDialog: MatDialog,
        private deleteReportFolderDialog: MatDialog,

    ) {

        this.thisDialogRef = reportFoldersDialogRef;
        this.angularMatData = new TylerMatTableDataSource(this.reportFolders);

    }

    ngOnInit() {
        this.reportFolders = this.reportService.ReportFolders;
        this.reportFoldersOnLoad = this.reportFolders;
        this.isDirty = false;
        this.loadReportData();
        if (this.reportService.inDebugMode) {
            console.log('Report-Folders Component ngOnInit()');

        }
    }

    ngOnDestroy() { }

    loadReportData(): void {
        // load data into Angular Material table
        this.angularMatData.data = this.reportFolders;
        if (this.reportService.inDebugMode) {
            console.log('Report-Folders Component =>  angularMatData');
            console.log(this.reportFolders);
            console.log(this.angularMatData);
        }
    }
    folderDeleteClick(folder: ReportFolder) {
        this.reportService.reportFolderIdToDelete = folder.Id;
        this.reportService.reportFolderNameToDelete = folder.Name;
        this.deleteReportFolderDialogRef = this.deleteReportFolderDialog.open(DeleteReportFolderComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true
        });

        this.deleteReportFolderDialogRef.afterClosed().subscribe(result => {

            if (this.reportService.inDebugMode) {
                console.log('deleteReportFolderDialogRef.afterClosed()');
            }

            if (result == true) {
                // we need to refresh report folders

                this.getMyReportFolders();
            }

        });
    }

    folderEditClick(folder: ReportFolder) {
        this.reportService.isFolderEdit = true;
        this.reportService.ReportFolderToEdit = folder;

        // use add folder dialog - prepopulate name and desc
        this.addReportFolderDialogRef = this.addReportFolderDialog.open(AddReportFolderComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true
        });

        this.addReportFolderDialogRef.afterClosed().subscribe(result => {

            if (this.reportService.inDebugMode) {
                console.log('addReportFolderDialogRef.afterClosed()');
            }

            if (result == true) {
                // we need to refresh report folders

                this.getMyReportFolders();
            }

        });
    }

    addFolderClick() {

        this.reportService.isFolderEdit = false;
        this.addReportFolderDialogRef = this.addReportFolderDialog.open(AddReportFolderComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true
        });

        this.addReportFolderDialogRef.afterClosed().subscribe(result => {

            if (this.reportService.inDebugMode) {
                console.log('addReportFolderDialogRef.afterClosed()');
            }

            if (result == true) {
                // we need to refresh report folders

                this.getMyReportFolders();
            }

        });


    }

    getMyReportFolders(): void {
        this.reportService.getMyReportFolders().subscribe(folders => {
            this.reportFolders = folders;
            this.reportService.ReportFolders = this.reportFolders;
            this.loadReportData();
        });
    }


    closeClick() {
        if (this.reportFolders == this.reportFoldersOnLoad) {
            this.isDirty = false;
        } else {
            this.isDirty = true;

        }

        if (this.reportService.inDebugMode) {
            console.log('isDirty: ' + this.isDirty);
        }

        this.thisDialogRef.close(this.isDirty);
    }


    saveFolderReports(selectedFolderIds: number[]) {

        // // we need to save the report folders
        // this.reportService.saveFolderReports(this.reportService.login_ID, this.selectedReport.Id, selectedFolderIds).subscribe(results => {
        //     this.thisDialogRef.close('Folders Saved');
        // });
    }

}